import axios from '../axios/axios-auth'

export default class WorkDataUploadService {

    sendWorkData(orgId, formData) {
        return axios.post(`/third-party-data-service/v1/work-data/${orgId}`, formData, {headers:{"Content-Type": "multipart/form-data"}});
    }

}
